/**
 * @file index.ts
 * @description Public surface of the i18n runtime.
 *
 * A pure barrel. The instance itself lives in `./instance` so that re-exporting
 * `I18nProvider` here — which needs the instance — does not create a cycle.
 * @module i18n
 */
export { AppLocaleSync } from "./AppLocaleSync";
export { I18nProvider } from "./I18nProvider";
export { createI18nInstance, i18n, setAppLocale } from "./instance";
export { isUiLocalizationEnabled } from "./killSwitch";
export { buildInitOptions } from "./options";
export { CATALOG_LOCALES, I18N_NAMESPACE, resources } from "./resources";
export {
  useAppLocale,
  useLocaleFormat,
  type LocaleFormat,
} from "./useLocaleFormat";
